module.exports = __webpack_public_path__ + "static/media/side1.f644b08c.jpeg";